import { styled } from 'linaria/react';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  min-width: 100%;
  width: 100%;

  @media (--only-mobile) {
    margin-top: var(--space-300);
  }
`;

export const InputContainerRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-200);
  width: 48%;

  @media (--from-tablet) {
    margin-bottom: var(--space-350);
  }

  @media (--only-mobile) {
    width: 100%;
    margin-bottom: var(--space-350);

    &:last-of-type {
      margin-top: 0;
    }
  }
`;

export const InputContainerColumn = styled.div`
  display: flex;
  gap: var(--space-150);

  @media (--from-tablet) {
    flex-basis: 48.5%;
    width: 100%;
  }

  @media (--only-mobile) {
    flex-basis: 100%;
  }
`;

export const HintContainer = styled.div`
  margin-top: var(--space-100);
`;
